var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsultingProp2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 119,
    viewBox: "0 0 93 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1298 12.5502C12.8098 12.7002 12.4198 12.6602 12.1298 12.4202L0.349773 2.73025C-0.0602267 2.39025 -0.120227 1.80025 0.219773 1.39025C0.549773 0.990247 1.14977 0.930247 1.54977 1.26025L13.3298 10.9602C13.7298 11.2902 13.7898 11.8902 13.4598 12.2902C13.3698 12.4002 13.2498 12.4902 13.1298 12.5502Z",
    fill: "url(#paint0_linear_971_876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39025 13.5902C2.07025 13.7402 1.68025 13.7002 1.39025 13.4602C0.990247 13.1302 0.930247 12.5302 1.26025 12.1302L10.9502 0.350208C11.2802 -0.0497916 11.8802 -0.109792 12.2802 0.220208C12.6802 0.550208 12.7402 1.15021 12.4102 1.55021L2.72025 13.3402C2.63025 13.4502 2.51025 13.5402 2.39025 13.6002V13.5902Z",
    fill: "url(#paint1_linear_971_876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6199 109.501C79.1899 109.531 79.6199 110.001 79.5999 110.571L79.2899 117.251C79.2599 117.821 78.7899 118.251 78.2199 118.231C77.6599 118.201 77.2199 117.731 77.2399 117.161L77.5499 110.481C77.5799 109.911 78.0599 109.481 78.6199 109.501Z",
    fill: "url(#paint2_linear_971_876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.46 91.2204C80.03 91.2504 80.46 91.7204 80.44 92.2904L80.12 99.3104C80.09 99.8804 79.62 100.31 79.05 100.29C78.49 100.26 78.05 99.7904 78.07 99.2204L78.39 92.2004C78.42 91.6404 78.9 91.2004 79.46 91.2204Z",
    fill: "url(#paint3_linear_971_876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3998 103.131L73.7398 103.471C74.2998 103.501 74.7398 103.981 74.7198 104.541C74.6898 105.101 74.2198 105.541 73.6498 105.521L66.3098 105.181C65.7498 105.151 65.3098 104.671 65.3298 104.111C65.3598 103.551 65.8298 103.111 66.3998 103.131Z",
    fill: "url(#paint4_linear_971_876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3402 103.951L91.3602 104.271C91.9202 104.301 92.3602 104.781 92.3402 105.341C92.3102 105.901 91.8302 106.341 91.2702 106.321L84.2502 106.001C83.6802 105.971 83.2502 105.491 83.2702 104.931C83.3002 104.371 83.7702 103.931 84.3402 103.951Z",
    fill: "url(#paint5_linear_971_876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.46 94.4707C70.72 94.4807 70.98 94.5907 71.17 94.8007L75.91 99.9907C76.29 100.411 76.26 101.051 75.84 101.441C75.42 101.821 74.77 101.791 74.39 101.371L69.65 96.1807C69.27 95.7607 69.3 95.1107 69.72 94.7307C69.93 94.5407 70.19 94.4507 70.46 94.4607V94.4707Z",
    fill: "url(#paint6_linear_971_876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.79 107.99C83.05 108 83.31 108.11 83.5 108.32L88.01 113.26C88.39 113.68 88.36 114.32 87.94 114.71C87.52 115.09 86.87 115.06 86.49 114.64L81.98 109.7C81.6 109.28 81.63 108.63 82.05 108.25C82.26 108.06 82.53 107.97 82.79 107.98V107.99Z",
    fill: "url(#paint7_linear_971_876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1099 95.2803C88.3699 95.2903 88.6299 95.4003 88.8199 95.6103C89.1999 96.0303 89.1699 96.6803 88.7499 97.0603L83.5599 101.8C83.1399 102.18 82.4899 102.15 82.1099 101.73C81.7299 101.31 81.7599 100.67 82.1799 100.28L87.3699 95.5403C87.5799 95.3503 87.8499 95.2603 88.1099 95.2703V95.2803Z",
    fill: "url(#paint8_linear_971_876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8394 107.391C75.0994 107.401 75.3594 107.511 75.5494 107.721C75.9294 108.141 75.8994 108.791 75.4794 109.171L70.2894 113.911C69.8694 114.291 69.2294 114.261 68.8394 113.841C68.4594 113.421 68.4894 112.771 68.9094 112.391L74.0994 107.651C74.3094 107.461 74.5794 107.371 74.8394 107.381V107.391Z",
    fill: "url(#paint9_linear_971_876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9402 94.3398C33.2802 94.3398 30.6802 93.0298 29.1502 90.6298C27.9902 88.8198 27.6102 86.6698 28.0802 84.5698C28.5402 82.4698 29.8002 80.6798 31.6102 79.5198C35.3502 77.1298 40.3302 78.2298 42.7102 81.9698C43.8702 83.7798 44.2502 85.9298 43.7802 88.0298C43.3202 90.1298 42.0702 91.9198 40.2602 93.0798C38.9202 93.9298 37.4302 94.3398 35.9402 94.3398ZM35.9202 79.7698C34.7202 79.7698 33.5002 80.0998 32.4102 80.7898C30.9402 81.7298 29.9202 83.1898 29.5402 84.8898C29.1602 86.5898 29.4702 88.3398 30.4102 89.8198C32.3502 92.8598 36.4002 93.7498 39.4402 91.8098C40.9102 90.8698 41.9302 89.4098 42.3002 87.7098C42.6802 86.0098 42.3702 84.2598 41.4302 82.7898C40.1802 80.8398 38.0702 79.7698 35.9102 79.7698H35.9202Z",
    fill: "url(#paint10_linear_971_876)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_971_876",
    x1: 43.1598,
    y1: -52.1798,
    x2: -103.14,
    y2: 185.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_971_876",
    x1: 43.1602,
    y1: -52.1798,
    x2: -103.14,
    y2: 185.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_971_876",
    x1: 142.85,
    y1: 9.16064,
    x2: -3.45012,
    y2: 246.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_971_876",
    x1: 135.37,
    y1: 4.56039,
    x2: -10.9298,
    y2: 242.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_971_876",
    x1: 132.5,
    y1: 2.80057,
    x2: -13.8002,
    y2: 240.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_971_876",
    x1: 145.76,
    y1: 10.9607,
    x2: -0.540052,
    y2: 248.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_971_876",
    x1: 131.72,
    y1: 2.32067,
    x2: -14.5802,
    y2: 240.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_971_876",
    x1: 146.56,
    y1: 11.4503,
    x2: 0.260139,
    y2: 249.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_971_876",
    x1: 141.18,
    y1: 8.14019,
    x2: -5.12029,
    y2: 245.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_971_876",
    x1: 136.959,
    y1: 5.54059,
    x2: -9.3406,
    y2: 243.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_971_876",
    x1: 99.7302,
    y1: -17.3702,
    x2: -46.5698,
    y2: 220.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#194378"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.34,
    height: 118.23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultingProp2);
export default __webpack_public_path__ + "static/media/ConsultingProp_2.2ee8d0d59b905f301541433c0199afff.svg";
export { ForwardRef as ReactComponent };